import React, { Component } from "react";
import { MisHeader } from "../mis.header";
import Pagination from "../../Pagination";
import {
  TableTemplate,
  ModalComponent,
  ModalTemplate,
  CopyToClipboard
} from "../../reusableComponent";

// bootstrap
import { Button, Form, Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import { get } from "lodash";
// redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { headerOptions, params } from "./nodalOfficerConstants";
import { toast } from "react-toastify";
import { isValidArray } from "../../../helper";
import {
  getNodalUserDetailsAction,
  updateDownloadNodalCommentAction
} from "../../../actions/nodalOfficer.action";
import {
  getNodalOfficerExcelReportAction,
  clearNodalOfficerExcelReportAction
} from "../../../actions/dowloadExcelActions";
import { successToastStyle, errorToastStyle } from "../../../customToast";
import Comment from "../../../assets/comment.svg";
import NoDataFound from "../../../component/NoDataFound";
import { SearchInMis } from "../../reusableComponent/search/serachForMisSection";
import { getGroupsForUserAction } from "../../../actions/userManagement.action";
import { element } from "screenfull";
import AppliedFilters from "../AppliedFilterDisplay";
import htmlToFormattedText from "html-to-formatted-text";

class NodalOfficerComponent extends Component {
  state = {
    listing: [],
    isLoading: false,
    isGroupNameSearhing: false,
    isUserNameSearhing: false,
    nodalOfficerParams: { ...params },
    groupName: "",
    userName: "",
    filtersApplied: []
  };

  componentDidMount() {
    const { getGroupsForUserAction } = this.props;
    this.getNodalUserDetails(false);
    getGroupsForUserAction(undefined);
  }

  getNodalUserDetails = pageChanged => {
    try {
      const { nodalOfficerParams, groupName, userName } = this.state;
      let offset;
      if (typeof pageChanged === "boolean") {
        offset = pageChanged ? nodalOfficerParams.offset : 0;
      } else {
        offset = userName.length !== 0 ? 0 : nodalOfficerParams.offset;
      }
      const payloadForNodal = {
        groupName: groupName,
        userName: userName,
        ...nodalOfficerParams,
        offset: offset
      };
      this.setState(
        {
          isLoading: true
        },
        async () => {
          const response = await getNodalUserDetailsAction(
            undefined,
            payloadForNodal
          );
          const { data } = response.data || {};
          const { nodalUserReportDTOS: Dto = [], total = 0 } = data || {};

          this.setState({
            listing: Dto,
            isLoading: false,
            userName: userName,
            groupName: groupName,
            nodalOfficerParams: {
              ...nodalOfficerParams,
              offset: offset,
              total: total
            }
          });
        }
      );
    } catch (e) {
      console.error("On Fetch ");
    }
  };

  onChange = value => {
    this.setState({
      userName: value
    });
  };

  onPageChange = value => {
    const { selected } = value;
    const pageChanged = true;
    this.setState(
      prevState => ({
        nodalOfficerParams: {
          ...prevState.nodalOfficerParams,
          offset: selected
        }
      }),
      () => {
        this.getNodalUserDetails(pageChanged);
      }
    );
  };

  // download noda officer detail
  onDownloadReport = () => {
    const { getNodalOfficerExcelReportAction } = this.props;
    const { nodalOfficerParams, userName, groupName } = this.state;
    const payload = {
      ...nodalOfficerParams,
      userName,
      groupName
    };
    getNodalOfficerExcelReportAction(payload);
  };

  // added comment
  onAddComment = ({ comment = "", id = null } = {}) => {
    this.setState(prevState => ({
      id,
      comment,
      showCommentPopUp: !prevState.showCommentPopUp
    }));
  };

  // submit the comment
  onSubmitComment = () => {
    try {
      const { comment, id: userId } = this.state;
      if (comment.length > 255) {
        toast.error(
          <p className="toast-text-alignment">
            Comment length should not exceed 255 characters.
          </p>,
          errorToastStyle
        );
        this.setState(
          {
            isCommentSubmitting: false
          },
          () => {
            this.onAddComment(); // close the comment pop up
            this.getNodalUserDetails(false); // get nodal officer detail
          }
        );
      } else {
        this.setState(
          {
            isCommentSubmitting: true
          },
          async () => {
            const response = await updateDownloadNodalCommentAction(undefined, {
              comment: comment.trim(),
              userId
            });
            const { data = {} } = response || {};
            const { status, message } = data;
            status
              ? toast.success(
                  <p className="toast-text-alignment">{message}</p>,
                  successToastStyle
                )
              : toast.error(
                  <p className="toast-text-alignment">{message}</p>,
                  errorToastStyle
                );
            this.setState(
              {
                isCommentSubmitting: false
              },
              () => {
                this.onAddComment(); // close the comment pop up
                this.getNodalUserDetails(false); // get nodal officer detail
              }
            );
          }
        );
      }
    } catch (e) {
      console.error("On Saving comment - ", e.message);
    }
  };

  // trigger on change of comment
  onChangeComment = e => {
    const { value } = e.target;
    this.setState({
      comment: value
    });
  };

  getFilterId = (value, elem) => {
    this.setState(
      {
        filtersApplied: elem.name === "Reset All" ? [] : [elem],
        groupName: elem.name === "Reset All" ? "" : elem.name
      },
      () => {
        this.getNodalUserDetails(false);
      }
    );
  };

  deleteFilter = () => {
    const { filtersApplied } = this.state;
    this.setState(
      {
        filtersApplied: [],
        groupName: ""
      },
      () => this.getNodalUserDetails(false)
    );
  };

  render() {
    const {
      state: {
        comment,
        listing,
        isLoading,
        showCommentPopUp,
        isUserNameSearhing,
        isCommentSubmitting,
        isGroupNameSearhing,
        userName,
        nodalOfficerParams: { total, limit, offset, groupName }
      },
      props: {
        nodalOfficerReducer,
        clearNodalOfficerExcelReportAction,
        groups
      },
      onChange,
      onAddComment,
      onPageChange,
      onChangeComment,
      onSubmitComment,
      onDownloadReport,
      getNodalUserDetails
    } = this;

    let filterList = [{ id: 0, name: "Reset All" }];
    if (isValidArray(get(groups, "data"))) {
      groups.data.forEach(elem => {
        filterList.push(elem);
      });
    }

    return (
      <div className="nodal-offiser-section">
        {showCommentPopUp ? (
          <ModalComponent
            centered={true}
            onClose={onAddComment}
            containerClass="nodal-officer-popup"
            isLoading={isCommentSubmitting}
            template={
              <ModalTemplate
                bodyTemplate={
                  <>
                    <h4>Add Comment</h4>
                    <Form.Control
                      as="textarea"
                      value={comment}
                      size="lg"
                      onChange={onChangeComment}
                      placeholder="Add your comment here"
                    />
                  </>
                }
                onSubmit={onSubmitComment}
                onClose={onAddComment}
                onSubmitTitle="Add"
              />
            }
          />
        ) : null}

        <MisHeader
          isLoading={nodalOfficerReducer.isLoading}
          downloadLink={nodalOfficerReducer.downloadingSrc}
          onStartDownloading={onDownloadReport}
          onClearDownload={clearNodalOfficerExcelReportAction}
          title="Nodal Officer Report"
          value={userName}
          data={getNodalUserDetails}
          isUserNameSearching={isUserNameSearhing}
          totalItem={this.state.nodalOfficerParams.total}
        />
        <SearchInMis
          keyName="userName"
          placeholder="Search"
          value={userName}
          onChange={onChange}
          callAfterDebounce={getNodalUserDetails}
          isLoading={isUserNameSearhing}
          isGroupNameSearching={true}
          filterList={filterList}
          getFilterId={this.getFilterId}
        />
        <div>
          <AppliedFilters
            filters={this.state.filtersApplied || []}
            isFromNodalSummary={true}
            deleteFilter={this.deleteFilter}
          />
          <Table striped size="sm" className="mis-project-list table-striped">
            <thead>
              <tr>
                <th className="nodal-user-column">User Name</th>
                <th className="nodal-user-id-column">User ID</th>
                <th className="nodal-group-column">Group Name</th>
                <th className="nodal-designation-column">Designation</th>
                <th className="nodal-email-column">Email</th>
                <th className="nodal-phone-column">Phone Number</th>
                <th className="nodal-comment-column">Comment</th>
              </tr>
            </thead>
            <tbody>
              {isValidArray(listing) ? (
                listing &&
                listing.map((data, index) => {
                  return (
                    <tr key={index}>
                      <td className="nodal-user-column">
                        <OverlayTrigger
                          placement="bottom-start"
                          key="bottom"
                          overlay={
                            <Tooltip
                              id="tooltip-bottom"
                              className="mis-tooltip"
                              placement="bottom-start"
                            >
                              {data.userName}
                            </Tooltip>
                          }
                        >
                          <div>{data.userName}</div>
                        </OverlayTrigger>
                      </td>
                      <td className="nodal-user-id-column">
                        <OverlayTrigger
                          placement="bottom-start"
                          key="bottom"
                          overlay={
                            <Tooltip
                              id="tooltip-bottom"
                              className="mis-tooltip"
                              placement="bottom-start"
                            >
                              {data.userID}
                            </Tooltip>
                          }
                        >
                          <div>{data.userID}</div>
                        </OverlayTrigger>
                      </td>
                      <td className="nodal-group-column">
                        <OverlayTrigger
                          placement="bottom-start"
                          key="bottom"
                          overlay={
                            <Tooltip
                              id="tooltip-bottom"
                              className="mis-tooltip"
                              placement="bottom-start"
                            >
                              {data.groupName}
                            </Tooltip>
                          }
                        >
                          <div>{data.groupName}</div>
                        </OverlayTrigger>
                      </td>
                      <td className="nodal-designation-column">
                        <OverlayTrigger
                          placement="bottom-start"
                          key="bottom"
                          overlay={
                            <Tooltip
                              id="tooltip-bottom"
                              className="mis-tooltip"
                              placement="bottom-start"
                            >
                              {data.designation}
                            </Tooltip>
                          }
                        >
                          <div>{data.designation}</div>
                        </OverlayTrigger>
                      </td>
                      <td className="nodal-email-column">
                        <OverlayTrigger
                          placement="bottom-start"
                          key="bottom"
                          overlay={
                            <Tooltip
                              id="tooltip-bottom"
                              className="mis-tooltip"
                              placement="bottom-start"
                            >
                              {data.email}
                            </Tooltip>
                          }
                        >
                          <div>{data.email}</div>
                        </OverlayTrigger>
                      </td>
                      <td className="nodal-phone-column">
                        {data.mobileNumber}
                      </td>
                      <td className="nodal-comment-column">
                        <Button
                          className="nodal-comment-btn"
                          variant={"outline-info"}
                          onClick={onAddComment.bind(this, {
                            comment: data.comment,
                            id: data.id
                          })}
                        >
                          <img src={Comment} className="comment-img" />
                          Comment
                        </Button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="7">
                    <NoDataFound />
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        {isValidArray(listing) ? (
          <div className="nodal-pagination">
            <Pagination
              offset={offset}
              pageCount={total / limit}
              onPageChange={onPageChange}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    nodalOfficerReducer: state.donwloadExcelReducer.nodalOfficer,
    groups: state.userManagementReducer.groups
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getNodalOfficerExcelReportAction,
      clearNodalOfficerExcelReportAction,
      getGroupsForUserAction
    },
    dispatch
  );
}

const NodalOfficer = connect(
  mapStateToProps,
  mapDispatchToProps
)(NodalOfficerComponent);

export { NodalOfficer };
